export default __webpack_public_path__ + "static/media/greenn.alt.67b4780b.png";